import React from 'react'
import classnames from "classnames";
import { Modal } from "react-bootstrap";

//import lib
import { toastAlert } from '../../lib/toastAlert';
import isEmpty from '../../lib/isEmpty'
import { PromotionEdit } from '../../actions/cmsActions';


const options = [{ 'value': "binance", 'label': "binance" }, { 'value': "off", 'label': "Off" }];


const initialFormValue = {
    "_id" : "",
    "Heading" : "",
    "SubHeading" : "",
    "images":[]
}

class EditpaymenttypeModal extends React.Component {
    constructor() {
        super();
        this.state = {
            formValue: initialFormValue,
            errors: {},
            loader: false
        };
    }

    handleChange = e => {
        e.preventDefault();
        let { name, id, value } = e.target;
        let formData = { ...this.state.formValue, ...{ [id]: value } };
        this.setState({ formValue: formData });
        if (!isEmpty(value)) {
            this.setState({ errors: {} })
        }
    };

    handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        // Check for file limit
        if (files.length + this.state.selectedFiles.length > 5) {
            toastAlert('error', 'You can only upload up to 5 images.');
            return;
        }

        // Store selected files and their previews
        const filePreviews = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        this.setState((prevState) => ({
            selectedFiles: [...prevState.selectedFiles, ...filePreviews],
        }));
    };

    handleRemoveImage = (index) => {
        this.setState((prevState) => {
            const updatedFiles = [...prevState.selectedFiles];
            updatedFiles.splice(index, 1);
            return { selectedFiles: updatedFiles };
        });
    };


    handleClose = () => {
        const { onHide } = this.props;
        onHide();
        this.setState({ 'formValue': initialFormValue, errors: {} });

    }

    handleSubmit = async e => {
        e.preventDefault();
        try {
            const { formValue, selectedFiles } = this.state;
            const { fetchData } = this.props;
            
            let reqData = formValue;
            this.setState({ 'loader': true })
            // let { status, loading, result, error, message,pairName } = await Addoffertaghook(reqData);
            const formData = new FormData();
            formData.append('_id', formValue._id);
            formData.append('Heading', formValue.Heading);
            formData.append('SubHeading', formValue.SubHeading);
console.log("selectedFiles",selectedFiles)
            selectedFiles.forEach((fileObj) => {
                formData.append('images', fileObj.file);
            });
            var result = await PromotionEdit(formData);
            console.log("Sdfadfasdasdasd",result)
            // this.setState({ 'loader': true })
            if (result?.result?.type === 'success') {
                fetchData();
                toastAlert('success', result?.result?.message, 'addTemplate');
                this.handleClose()
            } else {
                // if (result?.data?.error) {
                //     this.setState({ errors: result?.data?.error })
                //     this.setState({ 'loader': false })
                // }
                toastAlert('error', result?.result?.message, 'addSpotPair');
            }
            this.setState({ 'loader': false })
        }
        catch (err) { }
    }
    componentWillReceiveProps(nextProps){
        // var data = this.state.formValue || '';
        // data.Heading = nextProps?.record?.Heading || ""; 
        // data.SubHeading = nextProps?.record?.SubHeading || "";
        // data.images = nextProps?.record?.Images || [];
        // data._id = nextProps?.record?._id;
        // this.setState({formValue : data});
        this.setState({
            formValue: {
                _id: nextProps?.record?._id || '',
                Heading: nextProps?.record?.Heading || '',
                SubHeading: nextProps?.record?.SubHeading || '',
                images: [],
            },
            selectedFiles:  [],
        });
    }
    // nextProps?.record?.images?.map((img) => ({
    //     file: null,
    //     preview: img, // Use existing image URLs
    // })) ||
    render() {
        const { errors, loader ,selectedFiles} = this.state;
        const { Heading, SubHeading } = this.state.formValue

        const { isShow, currencyOptions } = this.props;


        return (
            <div>
                <Modal
                    show={isShow}
                    onHide={this.handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    size="lg"
                    centered
                    scrollable={true}
                >
                    <Modal.Header closeButton>
                        <h4 className="modal-title">Edit Social Media</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <form noValidate id="add-spot">
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Promotion Logo</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Heading}
                                        name="Heading"
                                        id="Heading"
                                        type="text"
                                        className={classnames("form-control", {
                                            invalid: errors.name
                                        })}
                                    />
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">SubHeading</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={SubHeading}
                                        name="SubHeading"
                                        id="SubHeading"
                                        type="text"
                                        className={classnames("form-control", {
                                           // invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">SubHeading</label>
                                </div>
                                <div className="col-md-9">
                                {/* <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={this.handleFileChange}
                                    className="form-control"
                                />
                                {errors.images && <span className="text-danger">{errors.images}</span>}

                                <div className="mt-2 d-flex flex-wrap">
                                    {selectedFiles?.map((file, index) => (
                                        <div key={index} className="position-relative m-2">
                                            <img
                                                src={file.preview}
                                                alt="Preview"
                                                style={{ width: 80, height: 80, borderRadius: 5, objectFit: 'cover' }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute"
                                                style={{ top: 0, right: 0 }}
                                                onClick={() => this.handleRemoveImage(index)}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div> */}
                                  {/* Hidden file input */}
        <input
            type="file"
            accept="image/*"
            multiple
            onChange={this.handleFileChange}
            className="d-none"
            ref={(input) => (this.fileInput = input)}
        />

        {/* Custom Upload Button */}
        <button
            type="button"
            className="btn btn-primary"
            onClick={() => this.fileInput.click()}
        >
            Upload Images
        </button>

        {errors.images && <span className="text-danger">{errors.images}</span>}

        {/* Image Previews */}
        <div className="mt-2 d-flex flex-wrap">
            {selectedFiles?.map((file, index) => (
                <div key={index} className="position-relative m-2">
                    <img
                        src={file.preview}
                        alt="Preview"
                        style={{ width: 80, height: 80, borderRadius: 5, objectFit: 'cover' }}
                    />
                    <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: 0, right: 0 }}
                        onClick={() => this.handleRemoveImage(index)}
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.handleClose}
                            disabled={loader}
                        >
                            Close
                        </button>
                        <button
                            onClick={this.handleSubmit}
                            className="btn btn-primary"
                            disabled={loader}
                        >
                            {loader && <i class="fas fa-spinner fa-spin"></i>}
                            Submit
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}



export default EditpaymenttypeModal;
